import * as React from "react"
import DebtDecompositionComponent, { DecompositionType, DataRow } from "./debt-decomposition-component"
import { Loan, LocalAuthority, LoanDecomposition, LoanWithDecomposition } from "../../../model"
import { getAnnuitySemestier, getAnnuity, getYearInterest, getYearReimboursedCapital, getYearRemainingCapital, getTotalInterestByYear, getLoansWithDecomposition } from "../../../domain/sfp/loan-domain";
import * as routes from '../../../util/routes'
import * as moment from "moment"
import * as Model from "../../../model"
import Operations from "../../scenarii/common/operations"
import TableDefinition, { TabId, Row, DicoChapter } from "../../scenarii/detail/table-definition"
import Spinner from "react-spinkit";
import "./../style.scss";

export default class DebtDecomposition
    extends React.Component<DebtDecompositionProps, State> {
    private tableDefs = {
        spending: TableDefinition
    }
    constructor(props) {
        super(props)
        this.state = {
            data: []
        }
    }

    componentDidMount() {
        if (this.props.loading) return
        this.initData(this.props)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.loading) return
        this.initData(nextProps)
    }

    render() {
        let data = []
        let mainData = this.state.data && this.state.data
        let len = mainData && mainData.length - 7
        let i
        if (mainData.length > 0) {
            for (i = 0; i < len; i++) {
                let values = []
                let key = []
                let obj = {};
                for (const val in mainData[i]) {
                    values.push(mainData[i][val] == 0 ? null : mainData[i][val])
                    key.push(val)
                }
                for (let i = 0; i < key.length; i++) {
                    obj[key[i]] = values[i];
                }
                data.push(obj)
            }
            for (i = len; i < mainData.length; i++) {
                data.push(mainData[i])
            }
        }

        return (!this.props.loading ? <DebtDecompositionComponent
            data={data}
            displayGraphic={this.props.displayGraphic}
            displaySimulate={this.props.displaySimulate}
            displaySimulateRécupérable={this.props.displaySimulateRécupérable}
            displayDette={this.props.displayDette}
            displayDetteSimuléeRécupérable={this.props.displayDetteSimuléeRécupérable}
            switchGraph={this.props.switchGraph}
            loading={this.props.loading}
            localAuthority={this.props.localAuthority}
            onClickCloseButton={this.props.onClickCloseButton}
            onClickSwitchButton={this.props.onClickSwitchButton}
            title={this.props.title}
            type={this.props.type}
            years={this.props.years} /> : <div className="waiting-loader">
            <Spinner fadeIn="none" name="wave" color="#3d3c3f" />
            <span>Chargement des données...</span>
        </div>
        )
    }

    private initData(props: DebtDecompositionProps) {
        if (!props.loansWithDecomposition) return
        if (!props.loansWithDecomposition.length) return
        if (props.loading) return

        const data: DataRow[] = []
        const displaySimulate = props.displaySimulate
        const displaySimulateRécupérable = props.displaySimulateRécupérable
        const displayDette = props.displayDette
        const displayDetteSimuléeRécupérable = props.displayDetteSimuléeRécupérable
        const totaldetteNormale = { loanWithDecomposition: { decomposition: null, loan: { simulate: false } as Loan }, linkSubject: null, linkNumber: 'Dette normale', isTitle: true }
        const totaldetteNormaleRécupérable = { loanWithDecomposition: { decomposition: null, loan: { simulate: false } as Loan }, linkSubject: null, linkNumber: 'Dette normale récupérable', isTitle: true }
        const totalDette = { loanWithDecomposition: { decomposition: null, loan: { simulate: false } as Loan }, linkSubject: null, linkNumber: 'Total Dette', isTitle: true }
        const totaldetteSimulée = { loanWithDecomposition: { decomposition: null, loan: { simulate: false } as Loan }, linkSubject: null, linkNumber: 'Dette simulée', isTitle: true }
        const totaldetteSimuléeRécupérable = { loanWithDecomposition: { decomposition: null, loan: { simulate: false } as Loan }, linkSubject: null, linkNumber: 'Dette simulée récupérable', isTitle: true }
        const totalSimulée = { loanWithDecomposition: { decomposition: null, loan: { simulate: false } as Loan }, linkSubject: null, linkNumber: 'Total dette simulée', isTitle: true }
        const total = { loanWithDecomposition: { decomposition: null, loan: { simulate: false } as Loan }, linkSubject: null, linkNumber: "Total", isTitle: true }

        this._initializeValues(total, props.years) // HERE...
        this._initializeValues(totaldetteNormale, props.years)
        this._initializeValues(totaldetteNormaleRécupérable, props.years)
        this._initializeValues(totalDette, props.years)
        this._initializeValues(totaldetteSimulée, props.years)
        this._initializeValues(totaldetteSimuléeRécupérable, props.years)
        this._initializeValues(totalSimulée, props.years)

        props.loansWithDecomposition.map(loanWithDecomposition => {
            const loan = loanWithDecomposition.loan
            if (!displaySimulate && loan.simulate && !loan.detteRecuperable) return
            if (!displaySimulateRécupérable && loan.simulate && loan.detteRecuperable) return
            if (!displayDette && !loan.simulate && !loan.detteRecuperable) return
            if (!displayDetteSimuléeRécupérable && !loan.simulate && loan.detteRecuperable) return
            const decomposition = loanWithDecomposition.decomposition
            const number = loan.number
            const subject = loan.subject
            const linkSubject = `/${this.props.localAuthority.slug}${routes.RETROSPECTIVE_DEBT}/${loan.id}`
            const linkNumber = `/${this.props.localAuthority.slug}${routes.RETROSPECTIVE_DEBT}/${loan.id}`
            const row: DataRow = { loanWithDecomposition, linkSubject, linkNumber }
            let dataleft

            /*year shifting calculation */
            let decom = {
                interests: [],
                paymentAmounts: [],
                paymentDates: [],
                periodicRates: [],
                reimboursedCapitals: [],
                remainingCapitals: []
            }
            decomposition.paymentDates.map((date, i) => {
                let payDate
                if (decomposition.remainingCapitals[i] > 0) {
                    //   if(loan.periodicity === 4){
                    // 	  let updatedDate= moment(date).add(3, 'M')	
                    // 	  payDate= moment(updatedDate).format()
                    // 	  payDate=new Date(payDate)
                    //   }else if(loan.periodicity === 1){
                    // 	  let updatedDate= moment(date).add(1, 'y')
                    // 	  payDate= moment(updatedDate).format()
                    // 	  payDate=new Date(payDate)
                    //   }else{
                    // 	  let updatedDate= moment(date).add(1, 'M')
                    // 	  payDate= moment(updatedDate).format()
                    // 	  payDate=new Date(payDate)
                    //   }
                    decom.interests.push(decomposition.interests[i])
                    decom.paymentAmounts.push(decomposition.paymentAmounts[i])
                    decom.paymentDates.push(date)
                    decom.periodicRates.push(decomposition.periodicRates[i])
                    decom.reimboursedCapitals.push(decomposition.reimboursedCapitals[i])
                    decom.remainingCapitals.push(decomposition.remainingCapitals[i])
                }
            })
            /*captial restant calculation adding data on created year*/
            dataleft = {
                interests: [],
                paymentAmounts: [],
                paymentDates: [],
                periodicRates: [],
                reimboursedCapitals: [],
                remainingCapitals: []
            }
            dataleft.interests.push("")
            dataleft.paymentAmounts.push(decomposition.paymentAmounts[0])
            // dataleft.paymentDates.push(this.getDateleftDate(loan.periodicity, decomposition.paymentDates[0]))
            dataleft.paymentDates.push(loan.contractedOn)
            dataleft.periodicRates.push("")
            dataleft.reimboursedCapitals.push(0)
            dataleft.remainingCapitals.push(decomposition.remainingCapitals[0])
            decomposition.paymentDates.map((date, i) => {
                let payDate
                if (decomposition.remainingCapitals[i] > 0) {
                    dataleft.interests.push(decomposition.interests[i])
                    dataleft.paymentAmounts.push(decomposition.paymentAmounts[i])
                    dataleft.paymentDates.push(date)
                    dataleft.periodicRates.push(decomposition.periodicRates[i])
                    dataleft.reimboursedCapitals.push(decomposition.reimboursedCapitals[i])
                    dataleft.remainingCapitals.push(decomposition.remainingCapitals[i])
                }
            })

            props.years.forEach((year, i) => {
                const yearIndex = year.toString()
                switch (props.type) {
                    case DecompositionType.Annuity:
                        row[yearIndex] = loan.periodicity == 2 ? getAnnuitySemestier(decom, year) : getAnnuity(decom, year)
                        total[yearIndex] += row[yearIndex]
                        if (!loanWithDecomposition.loan.detteRecuperable && !loanWithDecomposition.loan.simulate) {
                            totaldetteNormale[yearIndex] += row[yearIndex]
                        } else if (loanWithDecomposition.loan.detteRecuperable && !loanWithDecomposition.loan.simulate) {
                            totaldetteNormaleRécupérable[yearIndex] += row[yearIndex]
                        } else if (!loanWithDecomposition.loan.detteRecuperable && loanWithDecomposition.loan.simulate) {
                            totaldetteSimulée[yearIndex] += row[yearIndex]
                        } else if (loanWithDecomposition.loan.detteRecuperable && loanWithDecomposition.loan.simulate) {
                            totaldetteSimuléeRécupérable[yearIndex] += row[yearIndex]
                        }
                        if (!loanWithDecomposition.loan.simulate) {
                            totalDette[yearIndex] += row[yearIndex]
                        }
                        if (loanWithDecomposition.loan.simulate) {
                            totalSimulée[yearIndex] += row[yearIndex]
                        }
                        break
                    case DecompositionType.Interest:
                        row[yearIndex] = getYearInterest(decomposition, year)
                        total[yearIndex] += row[yearIndex]
                        if (!loanWithDecomposition.loan.detteRecuperable && !loanWithDecomposition.loan.simulate) {
                            totaldetteNormale[yearIndex] += row[yearIndex]
                        } else if (loanWithDecomposition.loan.detteRecuperable && !loanWithDecomposition.loan.simulate) {
                            totaldetteNormaleRécupérable[yearIndex] += row[yearIndex]
                        } else if (!loanWithDecomposition.loan.detteRecuperable && loanWithDecomposition.loan.simulate) {
                            totaldetteSimulée[yearIndex] += row[yearIndex]
                        } else if (loanWithDecomposition.loan.detteRecuperable && loanWithDecomposition.loan.simulate) {
                            totaldetteSimuléeRécupérable[yearIndex] += row[yearIndex]
                        }
                        if (!loanWithDecomposition.loan.simulate) {
                            totalDette[yearIndex] += row[yearIndex]
                        }
                        if (loanWithDecomposition.loan.simulate) {
                            totalSimulée[yearIndex] += row[yearIndex]
                        }
                        break
                    case DecompositionType.ReimboursedCapital:
                        row[yearIndex] = getYearReimboursedCapital(decom, year)
                        total[yearIndex] += row[yearIndex]
                        if (!loanWithDecomposition.loan.detteRecuperable && !loanWithDecomposition.loan.simulate) {
                            totaldetteNormale[yearIndex] += row[yearIndex]
                        } else if (loanWithDecomposition.loan.detteRecuperable && !loanWithDecomposition.loan.simulate) {
                            totaldetteNormaleRécupérable[yearIndex] += row[yearIndex]
                        } else if (!loanWithDecomposition.loan.detteRecuperable && loanWithDecomposition.loan.simulate) {
                            totaldetteSimulée[yearIndex] += row[yearIndex]
                        } else if (loanWithDecomposition.loan.detteRecuperable && loanWithDecomposition.loan.simulate) {
                            totaldetteSimuléeRécupérable[yearIndex] += row[yearIndex]
                        }
                        if (!loanWithDecomposition.loan.simulate) {
                            totalDette[yearIndex] += row[yearIndex]
                        }
                        if (loanWithDecomposition.loan.simulate) {
                            totalSimulée[yearIndex] += row[yearIndex]
                        }
                        break
                    case DecompositionType.RemainingCapital:
                        row[yearIndex] = getYearRemainingCapital(decom, year)
                        total[yearIndex] += row[yearIndex]
                        if (!loanWithDecomposition.loan.detteRecuperable && !loanWithDecomposition.loan.simulate) {
                            totaldetteNormale[yearIndex] += row[yearIndex]
                        } else if (loanWithDecomposition.loan.detteRecuperable && !loanWithDecomposition.loan.simulate) {
                            totaldetteNormaleRécupérable[yearIndex] += row[yearIndex]
                        } else if (!loanWithDecomposition.loan.detteRecuperable && loanWithDecomposition.loan.simulate) {
                            totaldetteSimulée[yearIndex] += row[yearIndex]
                        } else if (loanWithDecomposition.loan.detteRecuperable && loanWithDecomposition.loan.simulate) {
                            totaldetteSimuléeRécupérable[yearIndex] += row[yearIndex]
                        }
                        if (!loanWithDecomposition.loan.simulate) {
                            totalDette[yearIndex] += row[yearIndex]
                        }
                        if (loanWithDecomposition.loan.simulate) {
                            totalSimulée[yearIndex] += row[yearIndex]
                        }
                        break
                }
            })
            data.push(row)
        })
        data.push(totaldetteNormale)
        data.push(totaldetteNormaleRécupérable)
        data.push(totalDette)
        data.push(totaldetteSimulée)
        data.push(totaldetteSimuléeRécupérable)
        data.push(totalSimulée)
        data.push(total)
        this.setState({ data })
    }

    _initializeValues = (row, years) => {
        years.forEach(y => {
            row[y.toString()] = 0
        })
    }
}

export { DecompositionType }

export interface DebtDecompositionProps {
    displayGraphic: boolean
    displaySimulate: boolean,
    displaySimulateRécupérable: boolean,
    displayDette: boolean,
    displayDetteSimuléeRécupérable: boolean,
    switchGraph: string
    loading: boolean,
    loansWithDecomposition: LoanWithDecomposition[],
    localAuthority: LocalAuthority,
    onClickCloseButton(e: React.SyntheticEvent<Element>): any,
    onClickSwitchButton(e: React.SyntheticEvent<Element>): any,
    title: string,
    type: DecompositionType,
    years: number[],
    scenarii: any
    ppi: any
    services: any
    loans: any
}


interface State {
    data: DataRow[]
}


// WEBPACK FOOTER //
// ./src/component/debt/debt-decomposition/index.tsx